import React from "react";
import {
  Sparkles,
  Dumbbell,
  Brain,
  HeartHandshake,
  GraduationCap,
  Church,
  Heart,
  Users,
} from "lucide-react";

const NICHES = [
  {
    icon: Sparkles,
    title: "Beauty Professionals",
    desc: "Lash techs, estheticians, PMU artists, brow studios, nail techs.",
  },
  {
    icon: Brain,
    title: "Coaches & Consultants",
    desc: "Life, fitness, mindset, business, nutrition, and 1-on-1 coaches.",
  },
  {
    icon: Dumbbell,
    title: "Studios & Training Programs",
    desc: "Martial arts, yoga, Pilates, dance, niche fitness — anything membership-based.",
  },
  {
    icon: GraduationCap,
    title: "Schools & Academies",
    desc: "Tutoring centers, music & art schools, language academies, after-school programs, summer camps.",
  },
  {
    icon: Church,
    title: "Churches & Faith Communities",
    desc: "Service times, event RSVPs, ministry sign-ups, classes, retreats, donations.",
  },
  {
    icon: HeartHandshake,
    title: "Equestrian & Outdoor",
    desc: "Riding schools, stables, outdoor camps, dog trainers, adventure programs, retreats.",
  },
  {
    icon: Heart,
    title: "Wellness Practitioners",
    desc: "Massage therapists, acupuncturists, holistic providers, doulas, therapists.",
  },
  {
    icon: Users,
    title: "Non-profits & Programs",
    desc: "Community programs, volunteer sign-ups, event registrations, member organizations.",
  },
];

export default function NicheCallout() {
  return (
    <section
      id="who-this-is-for"
      data-testid="niche-section"
      className="section bg-nav-900/40 border-y border-nav-800"
    >
      <div className="container-x">
        <div className="max-w-3xl mx-auto text-center">
          <span className="eyebrow justify-center">
            <span className="h-1.5 w-1.5 rounded-full bg-brand" />
            Who this is built for
          </span>
          <h2 className="mt-4 h-display text-4xl sm:text-5xl">
            If your organization runs on{" "}
            <span className="text-brand">bookings, sign-ups, or members</span>
            {" "}— this was built for you.
          </h2>
          <p className="mt-4 text-lg text-nav-300">
            Not generic websites. Conversion-built funnels for any business
            or organization where structured registrations and scheduling make
            or break the month.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {NICHES.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              data-testid={`niche-item-${i}`}
              className="rounded-2xl border border-nav-800 bg-nav-900/70 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-brand/50 hover:shadow-[0_18px_36px_-18px_rgba(91,91,255,0.35)]"
            >
              <span className="grid place-items-center h-10 w-10 rounded-lg bg-brand/15 border border-brand/20 text-brand">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-3 font-display font-bold text-base text-white">
                {title}
              </h3>
              <p className="mt-1.5 text-xs text-nav-400 leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-nav-400">
          Don't see your niche? If you take registrations, bookings, or
          sign-ups of any kind — this works for you.
        </p>
      </div>
    </section>
  );
}
